import * as Types from "./mutation-type";
import { API_STATES } from "@/helpers";

const mutations = {
  [Types.CREATE_ONBOARDING_THIRD_STEP_DATA_BEGIN](state) {
    state.createOnBoardingThirdStepDataState = API_STATES.REQUEST_PENDING;
  },
  [Types.CREATE_ONBOARDING_THIRD_STEP_DATA_SUCCESS](state) {
    state.createOnBoardingThirdStepDataError = null;
    state.createOnBoardingThirdStepDataState = API_STATES.REQUEST_SUCCESS;
  },
  [Types.CREATE_ONBOARDING_THIRD_STEP_DATA_ERROR](state, err) {
    state.createOnBoardingThirdStepDataState = API_STATES.REQUEST_ERROR;
    state.createOnBoardingThirdStepDataError = err;
  },
  [Types.GET_ONBOARDING_THIRD_STEP_DATA_BEGIN] (state ) {
    state.getOnboardingThirdStepDataState = API_STATES.REQUEST_PENDING
    state.getOnboardingThirdStepDataError = null
  },
  [Types.GET_ONBOARDING_THIRD_STEP_DATA_SUCCESS] (state, data) {
    state.getOnboardingThirdStepDataState = API_STATES.REQUEST_SUCCESS
    state.onboardingThirdStepData = data
    state.getOnboardingThirdStepDataError = null
  },
  [Types.GET_ONBOARDING_THIRD_STEP_DATA_ERROR] (state,err) {
    state.getOnboardingThirdStepDataState = API_STATES.REQUEST_ERROR
    state.getOnboardingThirdStepDataError = err
  },
  [Types.GET_COMPANIES_BEGIN](state) {
    state.companiesGetState = API_STATES.REQUEST_PENDING;
  },
  [Types.GET_COMPANIES_SUCCESS](state, companies) {
    state.companiesGetError = null;
    state.companies = companies.list;
    state.companiesCount = companies.count
    state.companiesGetState = API_STATES.REQUEST_SUCCESS;
  },
  [Types.GET_COMPANIES_ERROR](state, err) {
    state.companiesGetState = API_STATES.REQUEST_ERROR;
    state.companiesGetError = err;
  },
  [Types.UPDATE_COMPANY_BEGIN](state) {
    state.companyUpdateState = API_STATES.REQUEST_PENDING;
  },
  [Types.UPDATE_COMPANY_SUCCESS](state) {
    state.companyUpdateError = null;
    state.companyUpdateState = API_STATES.REQUEST_SUCCESS;
  },
  [Types.UPDATE_COMPANY_ERROR](state, err) {
    state.companyUpdateState = API_STATES.REQUEST_ERROR;
    state.companyUpdateError = err;
  },
  [Types.DELETE_COMPANY_BEGIN](state) {
    state.companyDeleteState = API_STATES.REQUEST_PENDING;
  },
  [Types.DELETE_COMPANY_SUCCESS](state) {
    state.companyDeleteError = null;
    state.companyDeleteState = API_STATES.REQUEST_SUCCESS;
  },
  [Types.DELETE_COMPANY_ERROR](state, err) {
    state.companyDeleteState = API_STATES.REQUEST_ERROR;
    state.companyDeleteError = err;
  },
};

export default mutations;